import { ProductType } from "features/applications/config";
import { loanFormFields } from "features/loanApplications/formFieldsConfig";
// import { APPROVED_LOAN_DETAILS } from "features/loanApplications/formFieldsConfig/ApproveLoanDetails";
// import { User } from "lucide-react";

// TODO: Remove below seciton
// loanFormFields.push({
//   sectionDescription: "Loan Approved Details",
//   section: "Loan Approved details",
//   name: "loanApprovalDetails",
//   fields: APPROVED_LOAN_DETAILS.fields,
//   icon: User,
// });

type NestedObject = { [key: string]: any };

function isNestedObject(value: any): boolean {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function flattenObject(obj: NestedObject): NestedObject {
  let result: NestedObject = {};

  // Iterate through each key in the object
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      // If the value is a nested object, merge its properties into the result
      if (isNestedObject(obj[key])) {
        result = { ...result, ...obj[key] };
      } else {
        // If it's a primitive or already flattened, just copy it
        result[key] = obj[key];
      }
    }
  }

  return result;
}

const transformFormDataDataForPost = async (formData: {
  [key: string]: any;
}) => {
  const result: any = {};
  
  // Log the original form data for debugging
  console.log("Original formData before transform:", formData);
  
  // Special handling for coApplicantDetails before flattening
  const coApplicantDetails = formData.coApplicantDetails;
  
  // Store the application ID before flattening to ensure it's preserved
  const applicationId = formData.id;
  
  const flattenFormData = flattenObject(formData);

  // Add specific outer-level fields
  const outerLevelFields = ["id", "productType", "addresses", "bankAccounts", "references", "coApplicantDetails"];
  
  // Ensure application ID is preserved first, using the stored value
  if (applicationId) {
    result["id"] = applicationId;
  }
  
  outerLevelFields.forEach((field) => {
    if (flattenFormData.hasOwnProperty(field)) {
      if (field === "id") {
        // Skip id as we've already handled it
        return;
      } else if (field === "productType") {
        result[field] =
          ProductType[flattenFormData[field] as keyof typeof ProductType] ||
          flattenFormData[field];
      } else if (field === "coApplicantDetails" && formData.coApplicantDetails) {
        // Handle coApplicantDetails specially to preserve its structure
        console.log("Processing coApplicantDetails in transform:", formData.coApplicantDetails);
        result[field] = formData.coApplicantDetails;
      } else {
        result[field] = flattenFormData[field];
      }
    } else if (field === "coApplicantDetails" && formData.coApplicantDetails) {
      // Ensure coApplicantDetails is included even if it's not in flattenFormData
      console.log("Adding coApplicantDetails from original formData:", formData.coApplicantDetails);
      result[field] = formData.coApplicantDetails;
    }
  });

  // Handle incomeDetails specially to preserve its structure
  if (formData.incomeDetails) {
    result.incomeDetails = {
      ...formData.incomeDetails,
      // Ensure assets is always an array
      assets: Array.isArray(formData.incomeDetails.assets) ? 
        formData.incomeDetails.assets : 
        (formData.incomeDetails.assets ? [formData.incomeDetails.assets] : []),
      // Only convert to numbers if values are not empty
      monthlyIncome: formData.incomeDetails.monthlyIncome !== "" && formData.incomeDetails.monthlyIncome !== undefined ? 
        parseFloat(formData.incomeDetails.monthlyIncome) : 
        formData.incomeDetails.monthlyIncome,
      otherMonthlyIncome: formData.incomeDetails.otherMonthlyIncome !== "" && formData.incomeDetails.otherMonthlyIncome !== undefined ? 
        parseFloat(formData.incomeDetails.otherMonthlyIncome) : 
        formData.incomeDetails.otherMonthlyIncome
    };
  }
  
  // Handle coApplicantDetails specially to preserve its structure
  if (coApplicantDetails) {
    console.log("Adding coApplicantDetails to result:", coApplicantDetails);
    result.coApplicantDetails = coApplicantDetails;
  }

  // Add sectioned fields
  loanFormFields.forEach((section: any) => {
    // Skip incomeDetails as we've already handled it specially
    if (section.name === 'incomeDetails') {
      return;
    }
    
    const sectionFields = (section.fields || []).reduce(
      (fieldsAcc: any, field: any) => {
        if (
          flattenFormData.hasOwnProperty(field.name) &&
          !outerLevelFields.includes(field.name)
        ) {

          // Handle memberId specially for membershipDetails section
          if (section.name === "membershipDetails" && field.name === "memberId") {
            // Only set id if it's not going to conflict with the application id
            if (flattenFormData[field.name] !== result["id"]) {
              fieldsAcc["id"] = flattenFormData[field.name];
            }
          } else {
            fieldsAcc[field.name] = flattenFormData[field.name];
          }
        }
        return fieldsAcc;
      },
      {}
    );

    if (Object.keys(sectionFields).length > 0) {
      result[section.name] = sectionFields;
    }
  });
  console.log("result", result);
  
  // Log the final result before returning
  console.log("Final transformed result:", result);
  return result;
};

export { transformFormDataDataForPost };
